import getSystem from './getSystem';
import { extendAtomProps, removeAtomsFromProps, filterAllowedAtoms } from './utils';

/**
 * @param {Object} props
 * @param {Array} allowed
 *
 * @returns - [className, style, restProps]
 *
 * @example
 * const [className, style, rest] = system({ m: 3, p: 2 }, ['marginProps']); // Will only return margin3 as className
 */
const system = (props, allowed) => {
  const allowedAtoms = extendAtomProps(allowed);
  const atomProps = filterAllowedAtoms(props, allowedAtoms);
  const {
    className,
    style,
    ...rest
  } = removeAtomsFromProps(props, allowedAtoms);
  const [systemClassName, systemStyle] = getSystem({
    ...atomProps,
    className,
    style
  });
  return [systemClassName, systemStyle, rest];
};
export default system;